<div class="pm-form-field-checkbox" *ngFor="let option of formField.options">
  <p-checkbox
    class="pm-form-field-checkbox-button"
    [name]="formField.value"
    [value]="option.value"
    [inputId]="option.value"
    [formControl]="ctrl"
  />
  @if(formField.link) {
  <pm-link [external]="true" [route]="formField.link">
    <label class="pm-form-field-checkbox-label p5 ml-2">
      {{ option.label }}
    </label> </pm-link
  ><pm-asterisk *ngIf="formField.required" />
  } @else {
  <label [for]="option.value" class="pm-form-field-checkbox-label p5 ml-2">
    {{ option.label }} <pm-asterisk *ngIf="formField.required" />
  </label>

  }
</div>
